import { Injectable, NgZone } from '@angular/core';
import { MatSnackBar } from '@angular/material/snack-bar';

@Injectable({ providedIn: 'root' })
export class NotificationService {

  constructor(
    private zone: NgZone,
    private snackBar: MatSnackBar
  ) {}

  showSuccess(message: string): void {
    this.zone.run(() => {
      this.snackBar.open(message, 'OK', {
        duration: 3000,
        horizontalPosition: 'center',
        verticalPosition: 'top',
        panelClass: ['success-snackbar']
      })
    })
  }

  showError(message: string): void {
    this.zone.run(() => {
      this.snackBar.open(message, 'OK', {
        duration: 5000,
        horizontalPosition: 'center',
        verticalPosition: 'top',
        panelClass: ['error-snackbar']
      })
    })
  }

  showWarning(message: string): void {
    this.zone.run(() => {
      this.snackBar.open(message, 'OK', {
        duration: 4000,
        horizontalPosition: 'center',
        verticalPosition: 'top',
        panelClass: ['warning-snackbar']
      })
    })
  }
}
